// styles/theme.js

export const common = {
  fonts: {
    body: `"Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"`,
    heading: `"Montserrat", "Segoe UI", Tahoma, Geneva, Verdana, sans-serif`,
    mono: `SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace`,
  },

  fontWeights: {
    light: 300,
    normal: 400,
    semibold: 600,
    bold: 700,
  },

  // 🔤 Font Sizes (Standard + Fluid)
  fontSizes: {
    xs: 'clamp(0.75rem, 0.7rem + 0.3vw, 0.875rem)',
    sm: 'clamp(0.875rem, 0.8rem + 0.4vw, 1rem)',
    md: 'clamp(1rem, 0.9rem + 0.5vw, 1.125rem)',
    lg: 'clamp(1.125rem, 1rem + 0.6vw, 1.25rem)',
    xl: 'clamp(1.25rem, 1.1rem + 0.8vw, 1.5rem)',
    xxl: 'clamp(1.5rem, 1.2rem + 1vw, 2rem)',
  },

  lineHeights: {
    dense: 1.2,
    normal: 1.5,
    relaxed: 1.75,
    heading: 1.125,
  },

  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '64px',
  },

  borderRadius: {
    sm: '4px',
    md: '6px',
    lg: '12px',
    pill: '9999px',
  },

  boxShadow: {
    light: '0 1px 3px rgba(0,0,0,0.12)',
    default: '0 2px 5px rgba(0,0,0,0.1)',
    medium: '0 4px 10px rgba(0,0,0,0.15)',
    heavy: '0 10px 20px rgba(0,0,0,0.2)',
  },

  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    largeDesktop: '1200px',
  },

  // 📱 Media Query Shortcuts
  mq: {
    mobile: '@media (max-width: 480px)',
    tablet: '@media (max-width: 768px)',
    desktop: '@media (max-width: 1024px)',
    largeDesktop: '@media (max-width: 1200px)',
  },

  sizes: {
    contentMaxWidth: '1800px',
    gutterMobile: '4px',
    gutter: '10px',
    gap: '64px',
  },

  transition: {
    default: 'all 0.3s ease',
    fast: 'all 0.15s ease',
  },

  opacity: {
    disabled: 0.65,
  },

  zIndex: {
    dropdown: 20,
    sticky: 30,
    fixed: 40,
    modalBackdrop: 50,
    modal: 60,
    popover: 70,
    tooltip: 80,
  },
};

export const lightTheme = {
  ...common,
  colors: {
    primary: '#00BEFF',
    primaryHover: '#4A88C8',
    disabled: '#bdbdbd',
    text: '#212121',
    background: '#f9f9f9',
    border: '#e0e0e0',
    error: '#e53935',
    focusOutline: '#a1ff00',
    danger: '#e53935',
    dangerHover: '#ab000d',
    success: '#4caf50',
    warning: '#ff9800',
    info: '#2196f3',
    codeBg: '#fff4db',
    codeText: '#8a6534',
    inputBg: '#fff',
    inputBorder: '#ccc',
    inputBorderFocus: '#00BEFF',
    inputText: '#212121',
    inputPlaceholder: '#999',
    grey: 'grey',
  },
};

export const darkTheme = {
  ...common,
  colors: {
    primary: '#00BEFF',
    primaryHover: '#4A88C8',
    disabled: '#555',
    text: '#e0e0e0',
    background: '#1F2D3D',
    border: '#e0e0e0',
    error: '#ef5350',
    focusOutline: '#a1ff00',
    danger: '#ef5350',
    dangerHover: '#c62828',
    success: '#66bb6a',
    warning: '#ffa726',
    info: '#29b6f6',
    codeBg: '#1e1e1e',
    codeText: '#ffd700',
    inputBg: '#1c1c1c',
    inputBorder: '#444',
    inputBorderFocus: '#00BEFF',
    inputText: '#e0e0e0',
    inputPlaceholder: '#888',
    grey: 'grey',
  },
};
